<template lang="pug">
  div.fantasy-navbar
    v-img.fantasy-navbar__fixed(:aspect-ratio="16/9" height="150" max-height="150" src="https://cdn.vuetifyjs.com/images/parallax/material.jpg")
      v-row.white--text.pa-2.fill-height.lightbox(align="end")
        v-col
          div.subheading {{ userName }}
    v-list.fantasy-navbar__scrollable.fantasy__scrollbar(dense)
      template(v-for="menuItem, index in menuList")
        v-expansion-panels(v-if="getTypeLink(menuItem) == 'collapsable' && getIsVisible(menuItem.link)"  :key="'menuItem'+index" accordion)
          v-expansion-panel
            v-expansion-panel-header(:class="{'v-expansion-panel-header--active-child': pathContain(menuItem.link)}")
              v-list-item-action.flex-grow-0.flex-shrink-0.mr-6
                v-icon {{ menuItem.icon }}
              v-list-item-content
                v-list-item-title {{ menuItem.title }}
            v-expansion-panel-content
              template(v-for="menuChild, ind in menuItem.children")
                router-link.fantasy-navbar__link(v-if="menuChild.link != ''"  :key="'menuChild'+ind"  :to="menuChild.link")
                  v-list-item(link)
                    v-list-item-action.mr-6
                      v-icon {{ menuChild.icon }}
                    v-list-item-content
                      v-list-item-title {{ menuChild.title }}
                v-list-item(v-else link  :key="'menuChild'+ind")
                  v-list-item-action.mr-6
                    v-icon {{ menuChild.icon }}
                  v-list-item-content
                    v-list-item-title {{ menuChild.title }}
        v-list-item(v-else-if="getTypeLink(menuItem) == 'emptylink' && getIsVisible(menuItem.link)"  :key="'menuItem'+index" link)
          v-list-item-action.mr-6
            v-icon {{ menuItem.icon }}
          v-list-item-content
            v-list-item-title {{ menuItem.title }}
        router-link.fantasy-navbar__link(v-else-if="getTypeLink(menuItem) == 'link' && getIsVisible(menuItem.link)"  :key="'menuItem'+index"  :to="menuItem.link")
          v-list-item(link)
            v-list-item-action.mr-6
              v-icon {{ menuItem.icon }}
            v-list-item-content
              v-list-item-title {{ menuItem.title }}
    div.fantasy-navbar__fixed
      ChangePasswordDialog(:user="user")
</template>

<script>

  import ChangePasswordDialog from "@/components/dialogs/edit/ChangePasswordDialog";

  export default {
    name: "FantasyNabvar",
    components: {
      ChangePasswordDialog,
    },
    props: {
      menuList: {
        type: Array,
        default: function(){
          return []
        }
      }
    },
    data:() => ({
      panelActive: null,
    }),
    computed: {
      userName(){
        return this.$store.state.userData.name || 'Nombre';
      },
      user(){
        return this.$store.state.userData;
      },
      currentPath(){
        return this.$route.path;
      },
    },
    methods:{
      pathContain(subUrl){
        return this.currentPath.includes(subUrl);
      },
      getTypeLink(item){
        if(item.children && item.children.length > 0){
          return 'collapsable';
        } else if (item.link == ''){
          return 'emptylink';
        } else {
          return 'link'
        }
      },
      getIsVisible(link){
        return this.hasPermission('components.navbars.fantasyNabvar.' + link);
      }
    }
  }
</script>

<style lang="sass">
  @import '@/styles/_variables.sass'
  .fantasy-navbar
    height: 100%
    max-height: 100%
    overflow: hidden
    display: flex
    flex-direction: column
    &__fixed
      flex: 0 0 auto
    &__scrollable
      flex: 1 1 auto
      overflow: auto
    .lightbox
      box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.4)
      background-image: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, transparent 72px)
    &__link
      display: block
      text-decoration: none
      transition: background-color 0.1s cubic-bezier(0.25, 0.8, 0.5, 1)
      &:hover
        background-color: $primary
        // background-color: $primary
      &.router-link-active,
      &.router-link-exact-active.router-link-active
        background-color: $primary
    .v-expansion-panel-header--active-child
      background-color: $primary
    .v-expansion-panel--active > .v-expansion-panel-header,
    .v-expansion-panel-header
      min-height: 40px
      padding: 0 16px
    .v-expansion-panels.v-expansion-panels--accordion
      border-radius: 0
      .v-expansion-panel
        background-color: transparent
        .v-expansion-panel-header
          transition: background-color 0.1s cubic-bezier(0.25, 0.8, 0.5, 1)
          &:hover
            background-color: $primary
        &::before
          box-shadow: none
        &--active
          background-color: transparent
          &::before
            box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)
    .v-list--dense .v-list-item .v-list-item__title
      font-size: 1rem
</style>